import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function SectionLink({
  label,
  onClick
}: {
  label: string;
  onClick: () => void;
}) {
  return <button type="button" onClick={onClick} className="group flex items-center gap-1 whitespace-nowrap text-[13px] font-semibold text-accent transition-colors duration-150 ease-out hover:text-accent/70 focus:outline-none focus-visible:underline" data-id="element-310" data-mp="1um3sfbhln9ux">
      {label}
      <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden data-id="element-311" data-mp="28g3geg73q73y" />
    </button>;
}